/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetProgramSheetRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetProgramSheetResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getProgramSheet = (request:GetProgramSheetRequest, options?: CashRequestOptions) => post<GetProgramSheetRequest, GetProgramSheetResponse>("/2.0/cash/get-program-sheet", request, {...options, rejectOnError: true })